import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxPaginationModule } from 'ngx-pagination';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { HaMainComponentComponent } from './components/ha-main-component/ha-main-component.component';
import { HaPatientListComponent } from './components/ha-patient-list/ha-patient-list.component';
import { HaCaseListComponent } from './components/ha-case-list/ha-case-list.component';
import { HaScheduledPatientComponent } from './components/ha-scheduled-patient/ha-scheduled-patient.component';
import { HaSystemSettingComponent } from './components/ha-system-setting/ha-system-setting.component';
import { HaCreateRoleComponent } from './components/ha-create-role/ha-create-role.component';
import { HaTagSharingComponent } from './components/ha-tag-sharing/ha-tag-sharing.component';
import { HaTemplateSharingComponent } from './components/ha-template-sharing/ha-template-sharing.component';
import { HaCaseGroupCreationComponent } from './components/ha-case-group-creation/ha-case-group-creation.component';
import { HaCreatesurveyComponent } from './components/ha-createsurvey/ha-createsurvey.component';
import { HaNewcasegroupcreationComponent } from './components/ha-newcasegroupcreation/ha-newcasegroupcreation.component';
import { HaNewUsermangementComponent } from './components/ha-new-usermangement/ha-new-usermangement.component';
import { HaNewLicenseManagementComponent } from './components/ha-new-license-management/ha-new-license-management.component';
import { HaDashboardComponentComponent } from './components/ha-dashboard-component/ha-dashboard-component.component';
import { HaRoleListPipePipe } from './pipes/HaRoleList.pipe';
import { CaseGroupCreationCodesPipePipe } from './pipes/CaseGroupCreationCodes.pipe';
import { CaseGroupCreationCptcodesPipePipe } from './pipes/CaseGroupCreationCptCodes.pipe';
import { CaseGroupCreationPrecodesPipePipe } from './pipes/CaseGroupCreationPreCodes.pipe';
import { CaseGroupCreationProccodesPipePipe } from './pipes/CaseGroupCreationProcCodes.pipe';
import { CaseGroupCreationMedcodesPipePipe } from './pipes/CaseGroupCreationMedCodes.pipe';
import { HaCaseListPatientFilterPipe } from './pipes/HaCaseListPatientFilter.pipe';
import { CaseGroupVendorsearchPipePipe } from './pipes/CaseGroupVendorSearch.pipe';
import { HaHeaderComponent } from './components/ha-header/ha-header.component';
import { HaSidebarComponent } from './components/ha-sidebar/ha-sidebar.component';
import { HaTemplateFilterPipe } from './pipes/HaTemplateFilter.pipe';
import { HaCaseGroupCreationPipePipe } from './pipes/HaCaseGroupCreation.pipe';
import { ScheduleModule, AgendaService, DayService, WeekService, WorkWeekService, MonthService } from '@syncfusion/ej2-angular-schedule';
import { DocumentEditorContainerModule, TextExportService, DocumentEditorContainerAllModule } from '@syncfusion/ej2-angular-documenteditor';
import { HaHeaderServiceService } from './services/HaHeader.service';
import { TagNcaseManagementService } from './services/TagNcaseManagement.service';
import { HaUpdatesService } from './services/HaUpdates.service';
import { HaCaselistServiceService } from './services/HaCaseList.service';
import { HasystemsettingsService } from './services/HaSystemSettings.service';
import { HaPatientlistService } from './services/HaPatientList.service';
import { HaSurveyserviceService } from './services/HaSurvey.service';
import { HaLicenseServiceService } from './services/HaLicense.service';
import { HaCasegroupcreationServiceService } from './services/HaCaseGroupCreation.service';
import { UsermanagementService } from './services/UserManagement.service';
import { HaRolemanagementserviceService } from './services/HaRoleManagement.service';
import { ScheduleServiceService } from './services/Schedule.service';
import { TokenExpireInterceptor } from '../../core/TokenExpireInterceptor.interceptor';
import { HaFeedbackComponent } from './components/ha-feedback/ha-feedback.component';
import { HaFeedbackserviceService } from './services/HaFeedback.service';
import { HaStarRatingComponent } from './components/ha-star-rating/ha-star-rating.component';
import { HaSurveymanagementCreateComponent } from './components/ha-surveymanagement-create/ha-surveymanagement-create.component';
import { HaSurveymainComponent } from './components/ha-surveymain/ha-surveymain.component';
import { HaSurveymanagementdisplayComponent } from './components/ha-surveymanagementdisplay/ha-surveymanagementdisplay.component';
import { HaSurveysearchPipePipe } from './pipes/HaSurveySearch.pipe';
import { HaCasecodecreationComponent } from './components/ha-casecodecreation/ha-casecodecreation.component';
import { TreeNodeeComponent } from './components/tree-nodee/tree-nodee.component';
import { ImportExportCodesService } from './services/ImportExportCodes.service';
import { HaCptUploadComponent } from './components/ha-cpt-upload/ha-cpt-upload.component';
import { HaTreeCptComponent } from './components/ha-tree-cpt/ha-tree-cpt.component';
import { HaHelpVideoComponent } from './components/ha-help-video/ha-help-video.component';
import { HaIcdcodeDatapipePipe } from './pipes/HaIcdCodeData.pipe';
import { HaEditcptpipePipe } from './pipes/HaEditCpt.pipe';
import { SelectDropDownModule } from 'ngx-select-dropdown'
import { HaCaselistSearchpipePipe } from './pipes/HaCaseListSearch.pipe';
import { HaSharePatientComponent } from './components/ha-share-patient/ha-share-patient.component';
import { SearchSharePatientPipe } from './pipes/SearchSharePatient.pipe';
import { HaFeedbacksearchFilterPipe } from './pipes/HaFeedbackSearchFilter.pipe';
import { HadminComponent } from './components/hadmin/hadmin.component';
import { HaHelpVideoPipePipe } from './pipes/HaHelpVideo.pipe';
import { HaHelpVideoServiceService } from './services/HaHelpVideo.service';
import { HaTemplateshareDoctorPipe } from './pipes/HaTemplateShareDoctor.pipe';
import { HaPatientShareDocPipePipe } from './pipes/HaPatientShareDoc.pipe';
import { HaScheduleShareDocPipePipe } from './pipes/HaScheduleShareDoc.pipe';
import { HaMultiPatsharePipePipe } from './pipes/HaMultiPatShare.pipe';
import { HaHeaderViewServiceService } from './services/HaHeaderView.service';
import { HaStatePipePipe } from './pipes/HaState.pipe';
import { ToolbarService } from '@syncfusion/ej2-angular-documenteditor';
import { HaConfirmpasswordDirectiveDirective } from './directives/HaConfirmPassword.directive';
import { HaSurveyPatientSearchPipePipe } from './pipes/HaSurveyPatientSearch.pipe';
// import { QRCodeModule } from 'ng-qrcode';
import { QRCodeModule } from 'angularx-qrcode';
import { HAROUTINGMODULE } from './HaRouting.module';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { SharedModule} from '../shared/shared.module'
import { RoleCardComponent } from './components/elements/role-card/role-card.component';
import { CaseGroupCardComponent } from './components/elements/case-group-card/case-group-card.component';
import { LicenseCardComponent } from './components/elements/license-card/license-card.component';
import { SurveyMainCardComponent } from './components/elements/survey-main-card/survey-main-card.component';
import { DashCardDetailsComponent } from './components/elements/dash-card-details/dash-card-details.component';
import { DashCardLinkComponent } from './components/elements/dash-card-link/dash-card-link.component';
import { PatientListCardComponent } from './components/elements/patient-list-card/patient-list-card.component';
import { PatientPanelLinksComponent } from './components/elements/patient-panel-links/patient-panel-links.component';
import { CaseListCardComponent } from './components/elements/case-list-card/case-list-card.component';
import { FeedbackCardComponent } from './components/elements/feedback-card/feedback-card.component';
import { ImportCodeDivComponent } from './components/elements/import-code-div/import-code-div.component';
import { ShareDivComponent } from './components/elements/share-div/share-div.component'


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    QRCodeModule,
    ScheduleModule,

    SelectDropDownModule,
    DocumentEditorContainerModule,
    NgxPaginationModule,
    InfiniteScrollModule,
    DocumentEditorContainerAllModule,
    SharedModule,


    HAROUTINGMODULE,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,

    })

  ],
  providers: [AgendaService, DayService, WeekService, WorkWeekService, MonthService,
    ToolbarService,
    HaHeaderServiceService,
    TagNcaseManagementService,
    HaUpdatesService, HaCaselistServiceService, HasystemsettingsService, HaPatientlistService,
    HaSurveyserviceService, HaLicenseServiceService,
    HaCasegroupcreationServiceService,
    UsermanagementService,
    HaFeedbackserviceService,
    HaRolemanagementserviceService,
    ImportExportCodesService,
    ScheduleServiceService,
    HaHelpVideoServiceService,
    HaHeaderViewServiceService,

    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenExpireInterceptor,
      multi: true
    },

  ],
  declarations: [

    HaMainComponentComponent,
    HaPatientListComponent,
    HaCaseListComponent,
    HaScheduledPatientComponent,
    HaDashboardComponentComponent,
    HaSystemSettingComponent,
    HaCreateRoleComponent,
    HaTagSharingComponent,
    HaTemplateSharingComponent,
    HaCaseGroupCreationComponent,
    HaCreatesurveyComponent,
    HaNewcasegroupcreationComponent,
    HaNewLicenseManagementComponent,
    HaHeaderComponent,
    HaSidebarComponent,
    HaRoleListPipePipe,
    HaNewUsermangementComponent,
    CaseGroupCreationCodesPipePipe,
    CaseGroupCreationCptcodesPipePipe,
    CaseGroupCreationPrecodesPipePipe,
    CaseGroupCreationProccodesPipePipe,
    CaseGroupCreationMedcodesPipePipe,
    HaCaseListPatientFilterPipe,
    HaTemplateFilterPipe,
    HaCaseGroupCreationPipePipe,
    CaseGroupVendorsearchPipePipe,
    HaFeedbackComponent,
    HaStarRatingComponent,
    HaSurveymanagementCreateComponent,
    HaSurveymainComponent,
    HaSurveymanagementdisplayComponent,
    HaSurveysearchPipePipe,
    HaCasecodecreationComponent,
    TreeNodeeComponent,
    HaCptUploadComponent,
    HaTreeCptComponent,
    HaHelpVideoComponent,
    HaIcdcodeDatapipePipe,
    HaEditcptpipePipe,
    HaCaselistSearchpipePipe,
    HaSharePatientComponent,
    SearchSharePatientPipe,
    HaFeedbacksearchFilterPipe,
    HadminComponent,
    HaHelpVideoPipePipe,
    HaTemplateshareDoctorPipe,
    HaPatientShareDocPipePipe,
    HaScheduleShareDocPipePipe,
    HaMultiPatsharePipePipe,
    HaStatePipePipe,
    HaConfirmpasswordDirectiveDirective,
    HaSurveyPatientSearchPipePipe,
    RoleCardComponent,
    CaseGroupCardComponent,
    LicenseCardComponent,
    SurveyMainCardComponent,
    DashCardDetailsComponent,
    DashCardLinkComponent,
    PatientListCardComponent,
    PatientPanelLinksComponent,
    CaseListCardComponent,
    FeedbackCardComponent,
    ImportCodeDivComponent,
    ShareDivComponent

  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class HaModuleModule { }
